import styled from 'styled-components';

const AddonItem = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, 45%);
`;

const AddonGroupName = styled.div`
  display: flex;
  align-items: center;

  > p {
    min-width: 120px;
    margin-left: 20px;
  }
`;

const CostAddonAndIconButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
`;

const CostAddon = styled.div`
  display: flex;
  align-items: center;
  background: ${p => p.theme.color.turquoise};
  border-radius: 5px;
  height: 20px;
  padding: 0 5px;

  > p {
    width: max-content;
  }
`;

const AdvDialogButton = styled.div`
  > svg {
    width: 20px;
    height: 20px;
    fill: ${p => p.theme.color.gray};
  }
`;

export const Styled = {
  AddonItem,
  AddonGroupName,
  CostAddonAndIconButtonWrapper,
  CostAddon,
  AdvDialogButton,
};
